<template>
	<div class="game-screen intro-screen">
		<div class="content">
			<div class="message" v-html="message"></div>
			<Button :action="loadGameBoard">{{ currentStageSettings.intro.button_text }}</Button>
		</div>
	</div>
</template>

<script>
import Button from '@/components/abstract/Button';
import scrambleText from '@/mixins/scramble-text';
import { elementsToStrings } from '@/mixins/text-wrapper';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'StageIntro',
	mixins: [scrambleText],
	components: {
		Button,
	},
	computed: {
		...mapGetters(["currentStageSettings"]),
		shouldWrapLetters() {
			return this.currentStageSettings.scramble_text
				|| this.currentStageSettings.intro.falling_letter;
		},
		message() {
			let message = this.currentStageSettings.intro.message;

			if (this.shouldWrapLetters) {
				message = this.wrapText(message);
			}

			return message;
		},
	},
	methods: {
		...mapActions(["loadGameBoard"]),
		wrapText(message) {
			const lines = this.buildLineArray(message);

			lines.forEach((line) => {
				const element = line;
				const words = this.buildWordArray(element.innerHTML);
				words.forEach(this.wrapWords);

				element.innerHTML = elementsToStrings(words);
			});


			return elementsToStrings(lines);
		},
		wrapWords(word) {
			const element = word;
			const letters = this.buildLetterArray(element.textContent);

			if (this.currentStageSettings.scramble_text) {
				this.scrambleText(letters);
			}

			element.innerHTML = elementsToStrings(letters);
		},
	},
};
</script>

<style lang="scss" scoped>
	.game-screen {
		background-image: none;
	}

	.content {
		width: 100%;
		text-align: center;
		padding: 1vh 1vw;
		max-width: 800px;
	}

	.message {
		margin-top: 2em;
		margin-bottom: 0;
		font-size: 42px;
		font-weight: 700;
		letter-spacing: .05em;
		line-height: 1.3;

		@include tablet {
			font-size: 38px;
		}

		@include mobile {
			font-size: 30px;
			padding: 0 2vw;
		}
	}

	.button {
		margin: 1em auto 0;
	}

	.message {
		/deep/ .line {
			display: block;

			@include desktop-sm {
				white-space: nowrap;
			}
		}

		/deep/ .word {
			display: inline-block;
			white-space: nowrap;
			margin-right: 1ch;
		}

		/deep/ .line:last-child .word:last-child .letter:last-child {
			display: inline-block;
			animation-name: hinge;
			animation-fill-mode: forwards;
			animation-delay: 3s;
			animation-duration: 2s;
			line-height: .85;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/StageIntro.vue